import { Archive } from 'lucide-react';
import { FilterBooleanConfig } from 'v5/patterns/filters/FilterWidget.types';

export function createProductionArchivedFilterConfig(): FilterBooleanConfig {
  return {
    label: 'Archived',
    icon: <Archive className="size-4" />,
    type: 'boolean',
    createDefaultValue: () => ({ operator: 'equal', value: false }),
    options: {
      valueLabel: 'Archived',
      subjectLabel: 'Production'
    }
  };
}
